import axios from 'axios';
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;


export const toggleSentimentAnalysis = async (idToken: string, accessToken: string, isEnabled: boolean) => {
    const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/subscriptions/sentimentToggle';
    return await axios.post(endpoint,
        { toggleKey: 'sentimentAnalysis', isEnabled },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`,
            }
        }
    );
};

export const toggleOutlook = async (idToken: string, accessToken: string, isEnabled: boolean) => {
    const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/subscriptions/outlookToggle';
    return await axios.post(endpoint,
        { toggleKey: 'outlook', isEnabled },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`,
            }
        }
    );
};

export const toggleWord = async (idToken: string, accessToken: string, isEnabled: boolean) => {
    const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/subscriptions/wordToggle';
    return await axios.post(endpoint,
        { toggleKey: 'word', isEnabled },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`,
            }
        }
    );
};

export const toggleTeams = async (idToken: string, accessToken: string, isEnabled: boolean) => {
    const endpoint = REACT_APP_API_URL + '/api/v1.0/desktop/subscriptions/teamsToggle';
    return await axios.post(endpoint,
        { toggleKey: 'teams', isEnabled },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`,
            }
        }
    );
};
